import { Injectable } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';
import { environment } from 'src/environments/environment';

import { DataSharingService, RestService, StorageService } from 'src/app/_core/services';
import { HttpParamService } from 'src/app/_core/services/api/http-param.service';
import { Observable } from 'rxjs';
import { PUT_CompanyIntegrationModel, RestResponse } from 'src/app/_shared/models';

const APIEndpoint: string = environment.APIEndpoint;
const APIVersion: string = environment.APIVersion;

const APIResourceCompanies: string = '/companies';
const APIResourceIntegrations: string = '/integrations';

@Injectable({
  providedIn: 'root'
})
export class IntegrationService {

  subscription: Subscription;

  public serviceUrl_Integrations: string;
  public serviceUrl_Company: string;

  constructor(private httpParamService: HttpParamService,
    private _shareData: DataSharingService,
    private _storage: StorageService,
    private _rest: RestService) {

      let entityId: string;

      this.subscription = this._shareData.currentCompany.subscribe(data => {
        if (data.companyId){
          entityId = `/${data.companyId}`;
        } else {
          entityId = `/${this._storage.readLocalStorage('entityId')}`;
        }

      // INTEGRATIONS
      // /companies/{{companyId}}/integrations
      this.serviceUrl_Integrations = APIEndpoint + APIVersion + APIResourceCompanies + entityId + APIResourceIntegrations;
      this.serviceUrl_Company = APIEndpoint + APIVersion + APIResourceCompanies + entityId;

    });
  }

  public getCompanyIntegrationsByIntegrationKeyName(integrationName: string): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_Integrations}/${integrationName}`);
  }

  public getGlobalIntegrationByIntegrationKeyName(integrationName: string): Observable<RestResponse> {
    return this._rest.get(`${this.serviceUrl_Integrations}/${integrationName}/global-settings`);
  }

  public deleteCompanyIntegrationByIntegrationId(integrationId: number): Observable<RestResponse> {
    return this._rest.delete(`${this.serviceUrl_Integrations}/${integrationId}`);
  }

  public updateCompanyIntegration(integrationId: number, bodyParams: PUT_CompanyIntegrationModel): Observable<any> {
    return this._rest.put(`${this.serviceUrl_Integrations}/${integrationId}`, bodyParams);
  }

  public createCompanyIntegrationKey(integrationId: number, bodyParams: any): Observable<any> {
    return this._rest.post(`${this.serviceUrl_Integrations}/${integrationId}/keys`, bodyParams);
  }

  public createCompanyIntegration(integrationId: number, bodyParams: any): Observable<any> {
    return this._rest.post(`${this.serviceUrl_Integrations}/${integrationId}`, bodyParams);
  }

  // ups shipping protection
  public createUpsShippingProtection(integrationId: number, bodyParams: any): Observable<any> {
    return this._rest.post(`${this.serviceUrl_Integrations}/${integrationId}`, bodyParams);
  }
  public putUpsShippingProtection(integrationId: number, bodyParams: any): Observable<any> {
    return this._rest.put(`${this.serviceUrl_Integrations}/${integrationId}/settings`, bodyParams);
  }
  public getShippingProtection(integrationId: number): Observable<any> {
    return this._rest.get(`${this.serviceUrl_Integrations}/${integrationId}/shipping-protection`);
  }

  public getSaleChannelsShippingProtections(){
    return this._rest.get(`${this.serviceUrl_Company}/shipping/list/sale-channels/shipping-protection`);
  }
  public getShippingZones(){
    return this._rest.get(`${this.serviceUrl_Company}/shipping-zone`);
  }

  public addShippingZone(data: any){
    return this._rest.post(`${this.serviceUrl_Company}/shipping-zone`, data);
  }
  public editShippingZone(id: number,data: any){
    return this._rest.put(`${this.serviceUrl_Company}/shipping-zone/${id}`, data);
  }
  public removeShippingZone(id: number) {
    return this._rest.delete(
      `${this.serviceUrl_Company}/shipping-zone/${id}`);
  }

  public getShippingZonesByAddress(companyIntegrationId: number, addressId: number){
    return this._rest.get(`${this.serviceUrl_Company}/shipping-zone/integration/${companyIntegrationId}/address/${addressId}/shippingMethods`);
  }
}
